import {
  type FavouriteStationsAdapter,
  favouriteStationsApi,
} from '@/lib/favouriteStations'
import type { FavouriteStationsResponse } from '@/types'

export const favouriteStationsAdapterApi: FavouriteStationsAdapter = {
  supportsSync: true,
  load: async () => {
    try {
      const result = await favouriteStationsApi.ky
        .get('user/favourite-stations')
        .json<FavouriteStationsResponse>()
      return Promise.resolve(result?.data ?? [])
    } catch (_e) {
      return Promise.reject()
    }
  },
  save: (ids) => Promise.resolve(ids),
  add: async (id) => {
    try {
      await favouriteStationsApi.ky.post('user/favourite-stations/add', {
        json: {
          id: id,
        },
      })

      return Promise.resolve(true)
    } catch (_e) {
      return Promise.resolve(false)
    }
  },
  remove: async (id) => {
    try {
      await favouriteStationsApi.ky.post('user/favourite-stations/remove', {
        json: {
          id: id,
        },
      })

      return Promise.resolve(true)
    } catch (_e) {
      return Promise.resolve(false)
    }
  },
}
